import React from 'react';
import { Link } from 'react-router-dom';
import Imageone from "../../images/Projects Completed/project-img-1.jpeg";
import Imagetwo from "../../images/Projects Completed/project-img-2.jpeg";
import Imagethree from "../../images/Projects Completed/project-img-3.jpg";
import Imagefour from "../../images/Projects Completed/project-img-4.jpeg";
import Imagefive from "../../images/Projects Completed/project-img-5.jpg";
import Imagesix from "../../images/Projects Completed/project-img-6.jpg";
import Imageseven from "../../images/Projects Completed/project-img-7.jpg";


const tools = [
  { img: Imageone, name: "image one" },
  { img: Imageseven, name: "image seven" },
  { img: Imagetwo, name: "image two" },
  { img: Imagethree, name: "image three" },
  { img: Imagefive, name: "image five" },
  { img: Imagefour, name: "image four" },
  { img: Imagesix, name: "image six" },
 
];

function Coming() {
  return (
    <div className="py-6">
      <div className="bg-white rounded-xl">
        <div className="mx-auto px-4 py-10 sm:px-10 sm:py-14">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {tools.map((tool, index) => (
              <Link
                key={index}
                to="#"
                className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50"
              >
                <div className="relative">
                  <img
                    src={tool.img}
                    alt={tool.name}
                    className="w-full h-64 object-cover transition-opacity duration-300 rounded-t-2xl"
                  />
                  {/* <div className="px-4 py-3 text-center">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                      {tool.name}
                    </h3>
                  </div> */}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Coming;
